export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
} as const

export type Route = (typeof ROUTES)[keyof typeof ROUTES]
